(function () {
  if (window.__tomoHyzCopyV2) return;
  window.__tomoHyzCopyV2 = true;
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('.hyz-lp .hyz-copy');
    if (!button) return;
    var root = button.closest('.hyz-lp');
    var code = root.querySelector('.hyz-code');
    if (!code || code.value.trim() !== '2026HYZT004') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var status = root.querySelector('.hyz-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'hyz-status';
      button.closest('.hyz-coupon-action').appendChild(status);
    }
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    var label = button.querySelector('span') || button;
    var finish = function (ok) {
      label.textContent = ok ? 'コピー済み' : 'コピー';
      status.textContent = ok ? '2026HYZT004 をコピーしました。' : 'コードを選択しました。長押し、または Ctrl+C / ⌘C でコピーしてください。';
      if (ok) button.focus({ preventScroll: true });
      else { code.focus({ preventScroll: true }); code.select(); code.setSelectionRange(0, code.value.length); }
      clearTimeout(button.hyzCopyTimer);
      if (ok) button.hyzCopyTimer = setTimeout(function () { label.textContent = 'コピー'; status.textContent = ''; }, 4000);
    };
    // Synchronous fallback keeps the user's click activation, including embedded previews.
    var field = document.createElement('textarea');
    field.value = code.value.trim();
    field.readOnly = true;
    field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;';
    document.body.appendChild(field);
    field.focus({ preventScroll: true }); field.select(); field.setSelectionRange(0, field.value.length);
    var copied = false;
    try { copied = document.execCommand('copy'); } catch (error) {}
    field.remove();
    if (copied) { finish(true); return; }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code.value.trim()).then(function () { finish(true); }, function () { finish(false); });
    } else finish(false);
  }, true);
})();
